import moment from 'moment';
import Request from 'utilities/Request';
import Transaction from 'models/Transaction';
import { ADD_BANK_TRANSACTION_AS_TRANSACTION_SUCCESS } from 'redux/actions/dashboard';

/**
 * The transactions page's Unbudgeted tab: bank records no budget transaction is linked to. Not kept
 * in the store, since only that tab reads them, a page at a time.
 */

export const unbudgetedSources = {
	IMPORTED: 'imported',
	PLAID: 'plaid',
	ALL: 'all',
};

export const unbudgetedShows = {
	/** Not hidden, and no matching transfer on another account: the ones worth a look. */
	REVIEW: 'review',
	VISIBLE: 'visible',
	HIDDEN: 'hidden',
};

/**
 * A page of them (account/unbudgeted). Resolves with { total, page, per_page, counts, transactions },
 * each transaction's amount in cents with money in positive.
 */
export const fetchUnbudgeted = ({ source, show, page }) => Request.apiv1Get('account/unbudgeted', { source, show, page })
	.then((response) => response.unbudgeted);

/** Hides a record from this tab and the month's bank activity, or with `hide` false, shows it again. */
export const setBankRecordHidden = (record, hide = true) => Request.apiv1Post('plaid/hide_transaction', {
	plaid_transaction_id: record.plaid_transaction_id,
	hide: hide ? 1 : 0,
});

/**
 * The budget transaction a record would become, as the month's bank activity makes one
 * (PlaidTransaction.createTransaction): the bank's name and date, and the amount in the budget's
 * sign, where spending is positive. Saving it links it to the record through plaid_transaction_id.
 */
export const bankRecordAsTransaction = (record) => Transaction.create({
	id: null,
	category_id: undefined,
	amount: -record.amount,
	where: record.name,
	transaction_date: moment(record.date, 'YYYY-MM-DD'),
	plaid_transaction_id: record.plaid_transaction_id,
});

/** Opens the edit popup on that transaction, unsaved. */
export const addBankRecordToBudget = (record) => ({
	type: ADD_BANK_TRANSACTION_AS_TRANSACTION_SUCCESS,
	payload: bankRecordAsTransaction(record),
});
